// hooks/useUserActivityTracker.js
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createUserActivity } from '../redux/slices/userActivitySlice';
import { closeSnackbar } from '../redux/slices/snackbarSlice';

// Activity Tracker
const useUserActivityTracker = () => {
    const location = useLocation();
    const userActivityRef = useRef(false);
    const dispatch = useDispatch();

    const { isSession } = useSelector((state) => state.session);
    const { open: isSnackbarOpen, severity } = useSelector((state) => state.snackbar);

    useEffect(() => {
        const data = {
            location,
        };

        if (isSnackbarOpen && severity !== 'success') {
            dispatch(closeSnackbar());
        }

        if (isSession  && !userActivityRef.current) {
            dispatch(createUserActivity(data));
            userActivityRef.current = true;
        }

        return () => {
            userActivityRef.current = false;
        };
    }, [dispatch, isSession, location]);
};

export default useUserActivityTracker;
